module.exports = __webpack_public_path__ + "img/d11.27881ea0.jpg";